import Card from "@mui/material/Card";
import SoftBox from "../../../components/SoftBox";
import SoftTypography from "../../../components/SoftTypography";
import SoftAvatar from "../../../components/Avatar";
import {Chip} from "@mui/material";
import PropTypes from "prop-types";

function StaffInfo({staff}) {
    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        return new Date(dateString).toLocaleDateString();
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'ACTIVE':
                return 'success';
            case 'INACTIVE':
                return 'error';
            case 'PENDING':
                return 'warning';
            default:
                return 'default';
        }
    };

    return (
        <Card sx={{height: "100%"}}>
            <SoftBox display="flex" justifyContent="space-between" alignItems="center" pt={2} px={2}>
                <SoftTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                    Staff Information
                </SoftTypography>
            </SoftBox>
            <SoftBox p={2}>
                <SoftBox display="flex" alignItems="center" mb={3}>
                    <SoftAvatar
                        src={staff?.profilePic ? `data:image/png;base64,${staff.profilePic}` : undefined}
                        alt={staff?.firstName}
                        size="lg"
                        shadow="md"
                    />
                    <SoftBox ml={2}>
                        <SoftTypography variant="h5" fontWeight="medium">
                            {staff?.firstName} {staff?.lastName}
                        </SoftTypography>
                        <SoftTypography variant="body2" color="text">
                            {staff?.designation}
                        </SoftTypography>
                    </SoftBox>
                </SoftBox>

                <SoftBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
                    <SoftBox component="li" display="flex" alignItems="center" py={1} pr={1}>
                        <SoftTypography variant="button" fontWeight="bold" textTransform="uppercase">
                            Email:&nbsp;
                        </SoftTypography>
                        <SoftTypography variant="body2" color="text">
                            {staff?.email}
                        </SoftTypography>
                    </SoftBox>
                    <SoftBox component="li" display="flex" alignItems="center" py={1} pr={1}>
                        <SoftTypography variant="button" fontWeight="bold" textTransform="uppercase">
                            Phone:&nbsp;
                        </SoftTypography>
                        <SoftTypography variant="body2" color="text">
                            {staff?.phoneNumber}
                        </SoftTypography>
                    </SoftBox>
                    <SoftBox component="li" display="flex" alignItems="center" py={1} pr={1}>
                        <SoftTypography variant="button" fontWeight="bold" textTransform="uppercase">
                            Branch:&nbsp;
                        </SoftTypography>
                        <SoftTypography variant="body2" color="text">
                            {staff?.branchName}
                        </SoftTypography>
                    </SoftBox>
                    <SoftBox component="li" display="flex" alignItems="center" py={1} pr={1}>
                        <SoftTypography variant="button" fontWeight="bold" textTransform="uppercase">
                            Designation:&nbsp;
                        </SoftTypography>
                        <SoftTypography variant="body2" color="text">
                            {staff?.designation}
                        </SoftTypography>
                    </SoftBox>
                    <SoftBox component="li" display="flex" alignItems="center" py={1} pr={1}>
                        <SoftTypography variant="button" fontWeight="bold" textTransform="uppercase">
                            Status:&nbsp;
                        </SoftTypography>
                        <Chip
                            label={staff?.status}
                            color={getStatusColor(staff?.status)}
                            size="small"
                        />
                    </SoftBox>
                    <SoftBox component="li" display="flex" alignItems="center" py={1} pr={1}>
                        <SoftTypography variant="button" fontWeight="bold" textTransform="uppercase">
                            Created:&nbsp;
                        </SoftTypography>
                        <SoftTypography variant="body2" color="text">
                            {formatDate(staff?.createdAt)}
                        </SoftTypography>
                    </SoftBox>
                </SoftBox>
            </SoftBox>
        </Card>
    );
}

StaffInfo.propTypes = {
    staff: PropTypes.shape({
        id: PropTypes.number,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        email: PropTypes.string,
        phoneNumber: PropTypes.string,
        profilePic: PropTypes.string,
        branchName: PropTypes.string,
        designation: PropTypes.string,
        status: PropTypes.string,
        createdAt: PropTypes.string,
        userRole: PropTypes.string
    })
};

export default StaffInfo;
